var WarmupQuestions = require("lib/academic/WarmupQuestions");
var TopicQuestion = require("components/writing/quizzes/warmups/TopicQuestion");

class NonFictionVocabularyQuestion extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	isConnotative() {
		return this.props.answers[NonFictionVocabularyQuestion.STEM][TOPIC_WORD_TYPE].includes("connotative");
	}
	isTechnical() {
		return this.props.answers[NonFictionVocabularyQuestion.STEM][TOPIC_WORD_TYPE].includes("technical");
	}

	getDisplayStatus() {
		var answers = this.props.answers[NonFictionVocabularyQuestion.STEM];
		if (answers == undefined || _.isEmpty(answers)) {
			return [HARD_WORD_STAGE];
		}

		if (!answers[HARD_WORD]) {
			return [HARD_WORD_STAGE];
		}

		if (this.props.level == "2" && !answers[HARD_WORD_PIECE]) {
			return [HARD_WORD_PIECE_STAGE];
		}

		if (!answers[TOPIC_WORD] || (this.props.level == "3" && !answers[TOPIC_WORD_TYPE])) {
			return [TOPIC_WORD_STAGE];
		}

		if (this.props.level == "1") {
			return [TOPIC_WORD_STAGE, true];
		}

		if (this.props.level == "2") {
			if (!answers[TOPIC_WORD_PIECE]) {
				return [TOPIC_WORD_PIECE_STAGE];
			}
			return [TOPIC_WORD_PIECE_STAGE, true];
		}

		if (!this.isTechnical()) {
			if (!answers[LITERAL_MEANING]) {
				return [MEANING_LITERAL_STAGE];
			}
			if (!answers[NONLITERAL_MEANING]) {
				return [MEANING_NONLITERAL_STAGE];
			}
			return [MEANING_NONLITERAL_STAGE, true];
		}

		if (!answers[TECHNICAL_MEANING]) {
			return [MEANING_TECHNICAL_STAGE];
		}

		return [MEANING_TECHNICAL_STAGE, true];
	}

	render() {
		var displayStatus = this.getDisplayStatus();
		var stage = displayStatus[0];
		var displayButton = displayStatus[1];
		if (displayButton) {
			var finishButtonDisplay = this.props.renderFinishButtonF();
		}

		var hardWordDisplay = (
			<div>
				{ this.props.getTextF("label1", HARD_WORD_STAGE) }
				{ this.props.renderInputF(HARD_WORD) }
			</div>
		);

		if (_.indexOf(STAGES, stage) > 0 && this.props.level == "2") {
			var hardWord = this.props.answers[NonFictionVocabularyQuestion.STEM][HARD_WORD];
			var hardReplacementsHash = {};
			hardReplacementsHash[WarmupQuestions.HARD_WORD] = hardWord;

			var hardWordPieceDisplay = (
				<div>
					{ this.props.getTextF("label1", HARD_WORD_PIECE_STAGE, hardReplacementsHash) }
					{ this.props.renderDropdownF("choices1", HARD_WORD_PIECE_STAGE, HARD_WORD_PIECE) }
				</div>
			);
		}

		if (_.indexOf(STAGES, stage) > 1) {
			if (this.props.answers[TopicQuestion.STEM]) {
				var topic = this.props.answers[TopicQuestion.STEM][TopicQuestion.MAIN_TOPICS].split(",")[0];
			} else {
				var topic = "MISSING TOPIC";
			}
			var mainTopicsReplacementsHash = {};
			mainTopicsReplacementsHash[WarmupQuestions.TOPIC] = topic;

			if (this.props.level == "3") {
				var additionalTopicWordDisplay = (
					<span>
						{ this.props.renderDropdownF("choices1", TOPIC_WORD_STAGE, TOPIC_WORD_TYPE, [HARD_WORD, TOPIC_WORD]) }
						{ this.props.getTextF("label2", TOPIC_WORD_STAGE) }
					</span>
				);
			}

			var topicWordDisplay = (
				<div>
					{ this.props.getTextF("label1", TOPIC_WORD_STAGE, mainTopicsReplacementsHash) }
					{ additionalTopicWordDisplay }
					{ this.props.renderInputF(TOPIC_WORD) }
				</div>
			);
		}

		if (_.indexOf(STAGES, stage) > 2) {
			var topicWord = this.props.answers[NonFictionVocabularyQuestion.STEM][TOPIC_WORD];
			var topicReplacementsHash = {};
			topicReplacementsHash[WarmupQuestions.ENTERED_WORD] = topicWord;
		}

		if (_.indexOf(STAGES, stage) > 2 && this.props.level == "2") {
			var topicWordPieceDisplay = (
				<div>
					{ this.props.getTextF("label1", TOPIC_WORD_PIECE_STAGE, topicReplacementsHash) }
					{ this.props.renderDropdownF("choices1", TOPIC_WORD_PIECE_STAGE, TOPIC_WORD_PIECE) }
				</div>
			);
		}

		if (_.indexOf(STAGES, stage) > 3 && !this.isTechnical()) {
			var label = this.isConnotative() ? "label1" : "label2";
			var literalMeaningDisplay = (
				<div>
					{ this.props.getTextF(label, MEANING_LITERAL_STAGE, topicReplacementsHash) }
					{ this.props.renderInputF(LITERAL_MEANING) }
				</div>
			);
		}

		if (_.indexOf(STAGES, stage) > 4 && !this.isTechnical()) {
			var label = this.isConnotative() ? "label1" : "label2";
			var nonliteralMeaningDisplay = (
				<div>
					{ this.props.getTextF(label, MEANING_NONLITERAL_STAGE, topicReplacementsHash) }
					{ this.props.renderInputF(NONLITERAL_MEANING) }
				</div>
			);
		}

		if (_.indexOf(STAGES, stage) > 5) {
			var technicalMeaningDisplay = (
				<div>
					{ this.props.getTextF("label1", MEANING_TECHNICAL_STAGE, topicReplacementsHash) }
					{ this.props.renderInputF(TECHNICAL_MEANING) }
				</div>
			);
		}

		return (
			<div>
				{ hardWordDisplay }
				{ hardWordPieceDisplay }
				{ topicWordDisplay }
				{ topicWordPieceDisplay }
				{ literalMeaningDisplay }
				{ nonliteralMeaningDisplay }
				{ technicalMeaningDisplay }
				{ finishButtonDisplay }
			</div>
		);
	}
}

NonFictionVocabularyQuestion.STEM = "nfvocab";

// stages
var HARD_WORD_STAGE = "hardword";
var HARD_WORD_PIECE_STAGE = "hardwordpiece";
var TOPIC_WORD_STAGE = "topicword";
var TOPIC_WORD_PIECE_STAGE = "topicwordpiece";
var MEANING_LITERAL_STAGE = "meaningliteral";
var MEANING_NONLITERAL_STAGE = "meaningnonliteral";
var MEANING_TECHNICAL_STAGE = "meaningtechnical";

var STAGES = [
	HARD_WORD_STAGE, HARD_WORD_PIECE_STAGE, TOPIC_WORD_STAGE, TOPIC_WORD_PIECE_STAGE,
	MEANING_LITERAL_STAGE, MEANING_NONLITERAL_STAGE, MEANING_TECHNICAL_STAGE
];

// answer keys
var HARD_WORD = "hard_word";
var HARD_WORD_PIECE = "hard_word_piece";
var TOPIC_WORD = "topic_word";
var TOPIC_WORD_PIECE = "topic_word_piece";
var TOPIC_WORD_TYPE = "topic_word_type";
var LITERAL_MEANING = "literal_meaning";
var NONLITERAL_MEANING = "nonliteral_meaning";
var TECHNICAL_MEANING = "technical_meaning";

NonFictionVocabularyQuestion.propTypes = PageStrictPropTypes({
	level: PropTypes.string.isRequired,
	answers: PropTypes.object.isRequired,
	getTextF: PropTypes.func.isRequired,
	renderDropdownF: PropTypes.func.isRequired,
	renderInputF: PropTypes.func.isRequired,
	renderFinishButtonF: PropTypes.func.isRequired,
});

module.exports = NonFictionVocabularyQuestion;


// WEBPACK FOOTER //
// ./modules/components/writing/quizzes/warmups/NonFictionVocabularyQuestion.js